import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/xero';

const exportByOrderRaw = (merchantId, branchId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${branchId}/order/export/list-details`,
		payload,
		{
			responseType: 'blob',
		}
	);
};
const exportByOrder = (merchantId, branchId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${branchId}/order/export/list`,
		payload,
		{
			responseType: 'blob',
		}
	);
};

const exportByPayment = (merchantId, branchId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${branchId}/invoice/export/list`,
		payload,
		{
			responseType: 'blob',
		}
	);
};

const exportByItemSale = (merchantId, branchId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${branchId}/item-sale/export/list`,
		payload,
		{
			responseType: 'blob',
		}
	);
};

const getItemAccountCode = () => {
	return Client.get(`/temp/api/xero-code`);
};
const saveItemAccountCode = (payload) => {
	return Client.post(`/temp/api/xero-code`, payload);
};

export default {
	exportByOrderRaw,
	exportByOrder,
	exportByPayment,
	exportByItemSale,
	getItemAccountCode,
	saveItemAccountCode,
};
